"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Radio = function (_a) {
    var label = _a.label, checked = _a.checked, onClick = _a.onClick, className = _a.className, disabled = _a.disabled;
    var handleChange = function () {
        if (!disabled && onClick) {
            onClick();
        }
        return false;
    };
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)("ui-theme ui-radio", disabled && 'disabled', className) },
        react_1.default.createElement("input", { type: "radio", className: (0, classnames_1.default)("ui-radio-input"), onChange: handleChange, disabled: disabled, checked: checked }),
        label && (react_1.default.createElement("label", { onClick: handleChange }, label))));
};
exports.default = Radio;
